import axios from 'axios';
import config from "./../config";


// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'https://chat.cirucredito.com/login';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE';



axios.defaults.headers.post['Access-Control-Allow-Origin'] = 'https://chat.cirucredito.com/login';
axios.defaults.headers.post['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.post['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE';




// intercepting to capture errors
axios.interceptors.response.use(function (response) {
    return response.data ? response.data : response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
        case 500: message = 'Internal Server Error'; break;
        case 401: message = 'Invalid credentials'; break;
        case 404: message = "Sorry! the data you are looking for could not be found"; break;
        default: message = error.message || error;
    }
    return Promise.reject(message);
});

/**
 * Sets the default authorization
 * @param {*} token 
 */
const setAuthorization = (token) => {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}



class APIClient {
    /**
     * Fetches data from given url
     */
    get = (url, params) => {
        return axios.get(url, params);
    }

    /**
     * post given data to url
     */
    create = (url, data) => {
        return axios.post(url, data);
    }

    /**
     * Updates data
     */
    update = (url, data) => {
        return axios.put(url, data);
    }


    /**
     * Updates data
     */
    patch = (url, data) => {
        return axios.patch(url, data);
    }

    /**
     * Delete 
     */
    deleteById = (url) => {
        return axios.delete(url);
    }   


    /**
     * uploadImage 
     */
    
    uploadFile = (url, formData) => {
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}

export { APIClient, setAuthorization };